import React, { FC, useEffect } from 'react';
import { AddFieldType } from './worksheet-form-component-edit-modal';
import { DraggableWorksheetFormComponent, FormElementFile, WorksheetFormElementOption } from '@packages/models/api';
import { FileField } from './file-fields';
import { useValidationField } from './hooks/useValidationField';
import AddField from './add-field';
import useTranslationData from './hooks/useTranslationData';

interface FormWorksheetEditFileProps extends DraggableWorksheetFormComponent {
    onChange({
        formElementFile,
        formElementDescription,
        formElementLabel,
        formElementTooltip,
        options,
    }: {
        formElementFile?: FormElementFile;
        formElementDescription?: string;
        formElementLabel?: string;
        formElementTooltip?: string;
        options?: WorksheetFormElementOption[];
    }): void;
    addField: AddFieldType;
    onModalHide?: (hide: boolean) => void;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormEditFile: FC<FormWorksheetEditFileProps> = ({
    formElementFile,
    formElementDescription,
    formElementLabel,
    formElementTooltip,
    onChange,
    onModalHide,
    addField,
    setIsValid,
}) => {
    const { draggableElementsDataTranslate } = useTranslationData();
    const {
        fieldHandlers: { handleRequired },
        fieldErrorMessages,
        isValid,
    } = useValidationField();

    useEffect(() => {
        setIsValid(isValid);
    }, [Object.keys(fieldErrorMessages || {})]);

    return (
        <>
            <AddField
                addFieldValues={addField}
                errorMessage={fieldErrorMessages?.questionLabel}
                formElementDescription={formElementDescription}
                formElementLabel={formElementLabel}
                formElementTooltip={formElementTooltip}
                handleRequired={handleRequired}
                onchangeText={onChange}
                showFileFieldUI={false}
            />
            <FileField
                accept={'*'}
                formElementFile={formElementFile}
                onChange={onChange}
                onModalHide={onModalHide}
                title={draggableElementsDataTranslate.title.files}
            />
        </>
    );
};
